'use client'

import { StoryTitle as StoryTitleComponent } from '@news12/storybook-news'

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import useRegion from '../../hooks/useRegion'
import { TopStory } from '../../types'

type StoryTitleProps = {
  story: TopStory
}

const StoryTitle = ({ story }: StoryTitleProps) => {
  const region = useRegion()

  const [clientOriginalPublishedAt, setClientOriginalPublishedAt] = useState<Date | null>(null)
  const [clientPublishedAt, setClientPublishedAt] = useState<Date | null>(null)

  useEffect(() => {
    setClientOriginalPublishedAt(new Date(story.originalPublishedAt))
    setClientPublishedAt(new Date(story.publishedAt))
  }, [story])

  const handleShare = useCallback(
    (method: string) => {
      const url = `https://${region.name}.news12.com/${story?.slug}`

      switch (method) {
        case 'link': {
          navigator.clipboard.writeText(url)
          break
        }
        case 'facebook': {
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank')
          break
        }
        case 'twitter': {
          window.open(`https://twitter.com/share?url=${url}`, '_blank')
          break
        }
      }
    },
    [region, story]
  )

  if (!clientOriginalPublishedAt || !clientPublishedAt) return null

  return (
    <StoryTitleComponent
      title={story.title}
      subTitle={story.description}
      authors={story.authorsData}
      date={clientOriginalPublishedAt}
      updatedAt={clientPublishedAt}
      onShare={handleShare}
    />
  )
}

export default StoryTitle
